import Rollbar, { Configuration } from "rollbar";
import { ENVIRONMENT, ROLLBAR_ACCESS_TOKEN } from "config_environment";

export const rollbarConfig: Configuration = {
	accessToken: ROLLBAR_ACCESS_TOKEN,
	environment: ENVIRONMENT,
	captureUncaught: true,
	captureUnhandledRejections: true,
	// TODO GETTING ROLLBAR ENABLED LATER
	enabled: true,
};

const rollbar = new Rollbar({
	...rollbarConfig,
});

export default rollbar;
